// Builds the step header for an action item on the metric detail page.
// Numbered steps use the Figma phrasing ("In step N");
// the non-numbered catch-all ("Additional resources") uses its own text.
// Detected via the "Step " prefix the numbered categories carry, so it
// survives renumbering without hardcoding a step number.
export function formatActionStepLabel(
  step?: number | null,
  stepText?: string | null,
): string | null {
  if (step == null) return null;
  if (stepText && !stepText.startsWith('Step ')) return stepText;
  return `In step ${step}`;
}
